import React, { FC } from "react";
import { Login } from "./Login";
import { LoginAction } from "./LoginAction";
import { useLocation } from "@tanstack/react-router";

export const LoginPage: FC = () => {
  const location = useLocation();
  const returnUrl = location.pathname + location.searchStr;
  return <Login action={LoginAction.Login} returnUrl={returnUrl} />;
};
